import React from "react" // useRef, useEffect // useState,
import { StaticImage } from "gatsby-plugin-image"
import {
  // Container,
  Navbar,
  Nav,
  NavDropdown,
  Tooltip,
  // Form,
  // FormControl,
  // Button,
  // Fade,
} from "react-bootstrap"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"

import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilePdf } from "@fortawesome/free-solid-svg-icons"
import { faGlobe } from "@fortawesome/free-solid-svg-icons"

const Navi = () => {
  const navDropdownMenu = (
    <button className="menu bg-transparent h-100 border-0">
      <i className="uil uil-bars text-white"></i>
      <span className="d-block text-white fw-bold">Menu</span>
    </button>
  )
  const navDropdownImport = (
    <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
      <i className="uil uil-import"></i>
    </div>
  )
  // const navDropdownShare = (
  //   <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
  //     <i className="uil uil-share-alt"></i>
  //   </div>
  // )
  // const navDropdownSearch = (
  //   <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
  //     <i className="bx bx-search"></i>
  //   </div>
  // )
  // const navDropdownGlobe = (
  //   <div className="text-white d-flex justify-content-center align-items-center text-decoration-none">
  //     <i className="bx bx-globe"></i>
  //   </div>
  // )

  // const [open, setOpen] = useState(false)
  return (
    <div className="nav2">
      <Navbar className="navbar py-0 fixed-top">
        <div className="navbar__wrapper d-flex align-items-center justify-content-between position-relative h-100">
          <div className="logo-box d-flex h-100 align-items-center hamburger">
            <NavDropdown
              title={navDropdownMenu}
              id="basic-nav-dropdown"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none"
            >
              <Nav.Link href="/report/ar6/wg2/">AR6 Report Home</Nav.Link>
              <NavDropdown title="About" id="basic-nav-dropdown" drop="end">
                <ul>
                  <li>
                    <Link to="/about/authors">Authors </Link>
                  </li>
                  <li>
                    <Link to="/about/working-group">Working Group </Link>
                  </li>
                  <li>
                    <Link to="/about/background">Background </Link>
                  </li>
                  <li>
                    <Link to="/about/factsheets">Fact Sheets </Link>
                  </li>
                  <li>
                    <Link to="/about/frequently-asked-questions">
                      Frequently Asked Questions
                    </Link>
                  </li>
                  <li>
                    <Link to="/about/how-to-cite-this-report">
                      How to cite this report
                    </Link>
                  </li>
                </ul>
              </NavDropdown>
              <NavDropdown title="Resources" id="basic-nav-dropdown" drop="end">
                <ul>
                  <li>
                    <Link to="/resources/press">Press </Link>
                  </li>
                  <li>
                    <Link to="/resources/presentations-and-multimedia">
                      Presentations and multimedia
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/spm-headline-statements">
                      SPM Headline Statements
                    </Link>
                  </li>
                  <li>
                    <Link to="/figures/summary-for-policymakers">
                      SPM Figures{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/translations">
                      Translations{" "}
                    </Link>
                  </li>
                  <li>
                    <Link to="/resources/external-resources">
                      External Resources
                    </Link>
                  </li>
                </ul>
              </NavDropdown>
              <Nav.Link href="https://www.ipcc.ch/report/ar6/wg2/downloads">Downloads</Nav.Link>
            </NavDropdown>
            <Link
              to="/"
              className="logo fw-bold text-white flex-column align-items-start text-decoration-none"
            >
              IPCC Sixth Assessment Report
              <small className="d-block opacity-75 nav-subtitle">
                Impacts, Adaptation and Vulnerability
              </small>
            </Link>
          </div>

          <div className=" h-100 d-flex list-top">
            <NavDropdown
              title="About"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none nav-item dropdown t-link"
            >
              <ul>
                <li>
                  <Link to="/about/authors">Authors </Link>
                </li>
                <li>
                  <Link to="/about/working-group">Working Group </Link>
                </li>
                <li>
                  <Link to="/about/background">Background </Link>
                </li>
                <li>
                  <Link to="/about/frequently-asked-questions">
                    Frequently Asked Questions
                  </Link>
                </li>
                <li>
                  <Link to="/about/factsheets">Fact Sheets </Link>
                </li>
                <li>
                  <Link to="/about/how-to-cite-this-report">
                    How to cite this report
                  </Link>
                </li>
              </ul>
            </NavDropdown>
            {/* <NavDropdown
              title="Report"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none nav-item dropdown t-link report-menu"
            >
              <ul>
                <li>
                  Working Group III: Mitigation of Climate Change
                </li>
              </ul>
              <ul>
                <li>
                  <p><b>Summary products</b></p>
                </li>
                <li>
                  <Link to="/chapter/summary-for-policymakers/">Summary for Policymakers </Link>
                </li>
                <li>
                  <Link to="/chapter/technical-summary/">Technical Summary</Link>
                </li>
                <li className="mt-3">
                  <p><b>Figures</b></p>
                </li>
                <li>
                  <Link to="/figures/" className="navi-figures">Figures </Link>
                </li>
              </ul>
              <ul>
                <li>
                  <p><b>Chapters</b></p>
                </li>
                <li>
                  <Link to="/chapter/chapter-1/">Chapter 1 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-2/">Chapter 2 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-3/">Chapter 3 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-4/">Chapter 4 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-5/">Chapter 5 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-6/">Chapter 6 </Link>
                </li>
              </ul>
              <ul>
                <li>
                  <p><b></b></p>
                </li>
                <li>
                  <Link to="/chapter/chapter-7/">Chapter 7 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-8/">Chapter 8 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-9/">Chapter 9 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-10/">Chapter 10 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-11/">Chapter 11 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-12/">Chapter 12 </Link>
                </li>
              </ul>
              <ul>
                <li>
                  <p><b></b></p>
                </li>
                <li>
                  <Link to="/chapter/chapter-13/">Chapter 13 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-14/">Chapter 14 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-15/">Chapter 15 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-16/">Chapter 16 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-17/">Chapter 17 </Link>
                </li>
              </ul>
              <ul>
                <li>
                  Other IPCC Sixth Assessment (AR6) Reports
                </li>
              </ul>
              <ul className="shtop">
                <li>
                  <span>Working Group I: </span><br />
                  <a href="">The Physical Science Basis</a>
                </li>
              </ul>
              <ul className="shtop">
                <li>
                  <span>Working Group II: </span><br />
                  <a href="">Impacts, Adaptation and Vulnerability</a>
                </li>
              </ul>
              <ul className="shtop">
                <li>
                  <span>Synthesis Report: </span><br />
                  <a href="">Climate Change 2023</a>
                </li>
              </ul>
            </NavDropdown> */}
            <NavDropdown
              title="Report"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none nav-item dropdown t-link report-menu"
            >
              <ul><li>Working Group II: Impacts, Adaptation and Vulnerability</li></ul>
              <ul>
                <li>
                  <p><b>Summary products</b></p>
                </li>
                <li>
                  <Link to="/chapter/summary-for-policymakers/">Summary for Policymakers </Link>
                </li>
                <li>
                  <Link to="/chapter/technical-summary/">Technical Summary</Link>
                </li>
                <li>
                  <p><b>Figures</b></p>
                </li>
                <li>
                  <Link to="/figures/" className="navi-figures">Figures </Link>
                </li>
              </ul>
              <ul>
                <li>
                  <p><b>Chapters</b></p>
                </li>
                <li>
                  <Link to="/chapter/chapter-1/">Chapter 1 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-2/">Chapter 2 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-3/">Chapter 3 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-4/">Chapter 4 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-5/">Chapter 5 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-6/">Chapter 6 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-7/">Chapter 7 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-8/">Chapter 8 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-9/">Chapter 9 </Link>
                </li>
              </ul>
              <ul>
                <li>
                  <p><b></b></p>
                </li>
                <li>
                  <Link to="/chapter/chapter-10/">Chapter 10 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-11/">Chapter 11 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-12/">Chapter 12 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-13/">Chapter 13 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-14/">Chapter 14 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-15/">Chapter 15 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-16/">Chapter 16 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-17/">Chapter 17 </Link>
                </li>
                <li>
                  <Link to="/chapter/chapter-18/">Chapter 18 </Link>
                </li>
              </ul>
              <ul>
                <li>
                  <p><b>Cross-Chapter Papers</b></p>
                </li>
                <li>
                  <Link to="/chapter/ccp1/">Cross-Chapter Paper 1 </Link>
                </li>
                <li>
                  <Link to="/chapter/ccp2/">Cross-Chapter Paper 2 </Link>
                </li>
                <li>
                  <Link to="/chapter/ccp3/">Cross-Chapter Paper 3 </Link>
                </li>
                <li>
                  <Link to="/chapter/ccp4/">Cross-Chapter Paper 4 </Link>
                </li>
                <li>
                  <Link to="/chapter/ccp5/">Cross-Chapter Paper 5 </Link>
                </li>
                <li>
                  <Link to="/chapter/ccp6/">Cross-Chapter Paper 6 </Link>
                </li>
                <li>
                  <Link to="/chapter/ccp7/">Cross-Chapter Paper 7 </Link>
                </li>
              </ul>
              <ul>
                <li>
                  <p><b>Annexes</b></p>
                </li>
                <li>
                  <Link to="/chapter/annex-i/" className="navi-figures">Annex I </Link>
                </li>
                <li>
                  <Link to="/chapter/annex-ii/" className="navi-figures">Annex II </Link>
                </li>
                <li>
                  <Link to="/chapter/annex-iii/" className="navi-figures">Annex III </Link>
                </li>
                <li>
                  <Link to="/chapter/annex-iv/" className="navi-figures">Annex IV </Link>
                </li>
                <li>
                  <Link to="/chapter/annex-v/" className="navi-figures">Annex V </Link>
                </li>
              </ul>
              <ul><li>Other IPCC Sixth Assessment (AR6) Reports</li></ul>
              <ul class="shtop">
                <li>
                  <span>Working Group I: </span><br />
                  <a target="_blank" href="https://www.ipcc.ch/report/ar6/wg1/">The Physical Science Basis</a>
                </li>
              </ul>
              <ul class="shtop">
                <li><span>Working Group III: </span><br />
                  <a target="_blank" href="https://www.ipcc.ch/report/ar6/wg3/">Mitigation of Climate Change</a>
                </li>
              </ul>
              <ul class="shtop">
                <li><span>Synthesis Report: </span><br />
                  <a target="_blank" href="https://www.ipcc.ch/report/ar6/syr/">Climate Change 2023</a>
                </li>
              </ul>
            </NavDropdown>
            <NavDropdown
              title="Resources"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none nav-item dropdown t-link"
            >
              <ul>
                <li>
                  <Link to="/resources/press">Press </Link>
                </li>
                <li>
                  <Link to="/resources/presentations-and-multimedia">
                    Presentations and multimedia
                  </Link>
                </li>
                <li>
                  <Link to="/resources/spm-headline-statements">
                    SPM Headline Statements
                  </Link>
                </li>
                <li>
                  <Link to="/figures/summary-for-policymakers">
                    SPM Figures{" "}
                  </Link>
                </li>
                <li>
                  <Link to="/resources/translations">
                    Translations{" "}
                  </Link>
                </li>
                <li>
                  <Link to="/resources/external-resources">
                    External Resources{" "}
                  </Link>
                </li>
              </ul>
            </NavDropdown>
            <NavDropdown
              title="Download"
              id="basic-nav-dropdown"
              drop="end"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none t-link"
            >
              <div className="download-boks">
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/wg2/downloads/report/IPCC_AR6_WGII_SummaryForPolicymakers.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Summary for Policymakers
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/wg2/downloads/report/IPCC_AR6_WGII_TechnicalSummary.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Technical Summary
                </Nav.Link>
                <Nav.Link
                  href="https://www.ipcc.ch/report/ar6/wg2/downloads/report/IPCC_AR6_WGII_FullReport.pdf"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Full Report
                </Nav.Link>
                <div className="d-flex flex-column flex-md-row align-items-center mt-1 justify-content-center gap-4">
                  <Link to="/downloads" className="nav-dl-link">
                    <button className="btn-ipcc btn btn-primary">
                      All downloads
                    </button>
                  </Link>
                </div>
                <div className="d-flex flex-column flex-md-row align-items-center mt-1 justify-content-center gap-4">
                  <Link to="/resources/translations" className="nav-dl-link">
                    <button className="btn-ipcc btn btn-primary">
                      Translations
                    </button>
                  </Link>
                </div>
              </div>
            </NavDropdown>
            <NavDropdown
              title={navDropdownImport}
              id="basic-nav-dropdown"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none icon-download"
            >
              <div className="download-boks">
                <h3 className="text-white dropdown-header">Download</h3>
                <Nav.Link href="/downloads">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Summary for Policymakers
                </Nav.Link>
                <Nav.Link href="/downloads">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Technical Summary
                </Nav.Link>
                <Nav.Link href="/downloads">
                  <FontAwesomeIcon icon={faFilePdf} style={{ color: "#fff" }} />
                  Full Report
                </Nav.Link>
                <div className="d-flex flex-column flex-md-row mt-4 align-items-center justify-content-center gap-4">
                  <a href="https://www.ipcc.ch/report/ar6/wg2/downloads/" className="nav-download-button">
                    <button className="btn-ipcc btn btn-primary">
                      All downloads
                    </button>
                  </a>
                </div>
              </div>
            </NavDropdown>
            {/* <NavDropdown
              title={navDropdownShare}
              id="basic-nav-dropdown"
              className="text-white d-flex justify-content-center align-items-center text-decoration-none social-drop"
            >
              <div className="download-boks social-nav" id="social-nav">
                <div className="d-flex align-items-left justify-content-between gap-3 flex-wrap">
                  <div className="s9-widget-wrapper mt-3 mb-3"></div>

                  <ul className="list-unstyled d-flex flex-column align-items-left mb-0">
                    <li>
                      <a
                        href="https://twitter.com/IPCC_CH"
                        className="text-white d-flex align-items-left gap-1 text-decoration-none"
                      >
                        <i className="uil uil-twitter me-1 h1"></i>
                        <p className="mb-0">Twitter</p>
                      </a>
                    </li>

                    <li>
                      <a
                        href="https://www.facebook.com/IPCC/"
                        className="text-white d-flex align-items-left gap-1 text-decoration-none"
                      >
                        <i className="uil uil-facebook me-1 h1"></i>
                        <p className="mb-0">Facebook</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </NavDropdown> */}
            {/* <NavDropdown title={navDropdownSearch} id="basic-nav-dropdown" className="text-white d-flex justify-content-center align-items-center text-decoration-none" align="end" >
          <NavDropdown.Item href="#action/3.4">
          <Form className="d-flex">
            <FormControl
              type="search"
              placeholder="Search"
              className="text-ends w-100 border-0"
              aria-label="Search"
            />
            <Button variant="outline-success">Search</Button>
          </Form>
          <p className="text-white mb-3 text-center pe-4 fst-italic">Tip: to search this section of
              the report use the browser’s built-in search (Cmmd/Control +F)</p>
          </NavDropdown.Item>
          <div className="download-boks">
          <h3 className="text-white dropdown-header">XXX Results</h3>
          <div className="box-white">
            <NavDropdown.Item href="#action/3.4">
              <strong>A.1.5</strong>...decrease in Arctic <span className="matched">sea ice</span> area between...
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.4">
            <strong>A.1.5</strong>...decrease in Arctic <span className="matched">sea ice</span> area between...
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.4">
            <strong>A.1.5</strong>...decrease in Arctic <span className="matched">sea ice</span> area between...
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.4">
            <strong>A.1.5</strong>...decrease in Arctic <span className="matched">sea ice</span> area between...
            </NavDropdown.Item>
            </div>
            </div>
        </NavDropdown>
        <NavDropdown title={navDropdownGlobe} id="basic-nav-dropdown" className="text-white d-flex justify-content-center align-items-center text-decoration-none" align="end" >
        <div className="download-boks">
        <h3 className="text-white dropdown-header">Language</h3>
          <NavDropdown.Item href="#action/3.4">
            <span className="">Language 1</span>
          </NavDropdown.Item>
          <NavDropdown.Item href="#action/3.4">
            <span className="">Language 2</span>
          </NavDropdown.Item>
          <NavDropdown.Item href="#action/3.4">
            <span className="">Language 3</span>
          </NavDropdown.Item>
          <NavDropdown.Item href="#action/3.4">
            <span className="">Language 4</span>
          </NavDropdown.Item>
          </div>
        </NavDropdown> */}

            <OverlayTrigger
              delay={{ hide: 150, show: 100 }}
              overlay={props => <Tooltip {...props}>Translations</Tooltip>}
              placement="left"
            >
              <Link to="/resources/translations"
                className="text-white d-flex justify-content-center align-items-center text-decoration-none t-link nav-item dropend translations-icon">
                <FontAwesomeIcon icon={faGlobe} style={{ color: "#ffffff" }} />
              </Link>
              {/* <a
                href="https://ipcc.ch/report/ar6/wg1/resources/translations/"
                className="text-white d-flex justify-content-center align-items-center text-decoration-none t-link nav-item dropend translations-icon"
              >
                <FontAwesomeIcon icon={faGlobe} style={{ color: "#ffffff" }} />
              </a> */}
            </OverlayTrigger>

            <div className="logo-box d-flex h-100 align-items-center gap-5">
              <a
                id="nav-primary-logo"
                class="ipcc-logo-svg"
                href="https://www.ipcc.ch"
              >
                <svg version="1.1" x="0px" y="0px" viewBox="0 0 82 50">
                  <path
                    d="M7.8,4.6C7.8,6.4,6.2,8,4.4,8C2.5,8,1,6.4,1,4.6c0-1.9,1.5-3.4,3.4-3.4C6.2,1.2,7.8,2.7,7.8,4.6z M1.6,42.7h5.6V10.7H1.6
V42.7z M29.3,13c2,1.8,2.9,4.1,2.9,7.2v13.4c0,3.1-1,5.5-2.9,7.2c-2,1.8-4,2.7-6.3,2.7c-2,0-3.7-0.5-5-1.5v6.8h-5.6V20.2
c0-3.1,1-5.5,2.9-7.2c2-1.8,4.3-2.7,7-2.7C25,10.2,27.4,11.1,29.3,13z M26.7,20.2c0-3.7-1.9-5.3-4.3-5.3c-2.4,0-4.3,1.6-4.3,5.3
v13.4c0,3.7,1.9,5.2,4.3,5.2c2.4,0,4.3-1.7,4.3-5.3V20.2z M46.8,10.2c-2.7,0-5,0.9-7,2.7c-2,1.8-2.9,4.1-2.9,7.2v13.4
c0,3.1,1,5.5,2.9,7.2c2,1.8,4.3,2.7,7,2.7c2.7,0,5-0.9,7-2.7c2-1.8,2.9-4.1,2.9-7.2v-3.2h-5.6v3.2c0,3.6-1.9,5.3-4.3,5.3
c-2.4,0-4.3-1.6-4.3-5.2V20.2c0-3.7,1.9-5.3,4.3-5.3c2.4,0,4.3,1.6,4.3,5.3v0.6h5.6v-0.6c0-3.1-1-5.5-2.9-7.2
C51.8,11.1,49.5,10.2,46.8,10.2z M81,20.8v-0.6c0-3.1-1-5.5-2.9-7.2c-2-1.8-4.3-2.7-7-2.7c-2.7,0-5,0.9-7,2.7
c-2,1.8-2.9,4.1-2.9,7.2v13.4c0,3.1,1,5.5,2.9,7.2c2,1.8,4.3,2.7,7,2.7c2.7,0,5-0.9,7-2.7c2-1.8,2.9-4.1,2.9-7.2v-3.2h-5.6v3.2
c0,3.6-1.9,5.3-4.3,5.3c-2.4,0-4.3-1.6-4.3-5.2V20.2c0-3.7,1.9-5.3,4.3-5.3c2.4,0,4.3,1.6,4.3,5.3v0.6H81z"
                  ></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </Navbar>
    </div>
  )
}
export default Navi